<template>
  <div class="l-header js-push-to-right">
    <div class="l-header__column l-header__column--left">
      <div class="l-header__btn-menu ssm-toggle-nav ssm-nav-visible">
        <svg  width="24" height="16" class="l-header__btn-menu--open">
          <use xlink:href="#ic-icon-menu" />
        </svg>
      </div>
      <!-- <div class="l-header__logo">
        <router-link to="/top">
          <img :src="logoUrl" class="header-logo" alt="" v-if="logoUrl">
        </router-link>
      </div> -->
    </div>
    <div class="l-header__column--center">{{shop && shop.name}}</div>
    <div class="l-header__column--right">
      <img src="/assets/images/icon/icon-info.svg" alt="" width="24" height="24" @click="$router.push('/announce/list')">
    </div>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import store from "../store";
import { getShop } from "../store/firestore";
import { IMG_HOST } from "../config/const";

export default Vue.extend({
  name: 'header_page',
  store,
  components: {
  },
  async created() {
    const shopId = store.getters.shopId;
    if (shopId) {
      this.shop = await getShop(shopId);
      this.logoUrl = IMG_HOST + this.shop.headerLogoImage;
    }
  },
  data() {
    return {
      shop: null,
      logoUrl: undefined,
    }
  },
})
</script>
